import React from 'react';
import PropTypes from 'prop-types';

const PricingCard = ({
  monthlyPrice,
  annualPrice,
  billingText = 'billed',
  className = '',
  showDivider = true,
}) => {
  return (
    <div className={`flex items-center gap-5 ${className}`}>
      <div className="flex w-33 py-5 flex-col items-center">
        <div className="flex items-center gap-1">
          <h3 className="text-gray-90 text-xl font-semibold leading-8 mb-0">
            {monthlyPrice}
          </h3>
          <span className="text-gray-90 text-sm font-normal leading-5 whitespace-nowrap">
            &nbsp;/ month
          </span>
        </div>
        <span className="text-gray-90 text-sm font-normal leading-5">
          {billingText} monthly
        </span>
      </div>

      {showDivider && <div className="w-px h-15 bg-gray-20"></div>}

      <div className="flex py-5 flex-col items-center">
        <div className="flex items-center gap-1">
          <h3 className="text-gray-90 text-xl font-semibold leading-8 mb-0">
            {annualPrice}
          </h3>
          <span className="text-gray-90 text-sm font-normal leading-5 whitespace-nowrap">
            &nbsp;/ year
          </span>
        </div>
        <span className="text-gray-90 text-sm font-normal leading-5">
          {billingText} annually
        </span>
      </div>
    </div>
  );
};

PricingCard.propTypes = {
  monthlyPrice: PropTypes.string.isRequired,
  annualPrice: PropTypes.string.isRequired,
  billingText: PropTypes.string,
  className: PropTypes.string,
  showDivider: PropTypes.bool,
};

export default PricingCard;
